import React from 'react';
import { useTranslation } from 'react-i18next';
import { getLang, getDayMonthAfterTomorrowString } from 'utils';

export const DATA_QA_DELIVERY_SEO_STUB = 'delivery-seo-stub';

type Props = {
  regionName: string;
};

export const PdpDeliverySEOStub: React.FC<Props> = ({ regionName }) => {
  const { t } = useTranslation();
  const lang = getLang();
  const date = getDayMonthAfterTomorrowString(lang);

  return (
    <div data-qa={DATA_QA_DELIVERY_SEO_STUB} hidden>
      <p>{t('product-info.delivery.available-to-order-one-hundred')}</p>
      <p>{regionName}</p>
      <p>{t('product-info.delivery.pickup')}</p>
      <p>{t('product-info.delivery.pickup-date', { date })}</p>
      <p>{t('product-info.delivery.today')}</p>
    </div>
  );
};
